import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { LeadForm } from "@/components/LeadForm";
import { PartnerBadgeRow } from "@/components/PartnerBadges";
import { CONTACT } from "@/data/site";

export function Footer() {
  return (
    <footer className="relative border-t border-white/5 bg-ink" data-testid="site-footer">
      {/* Big audit CTA */}
      <section id="audit" className="relative overflow-hidden py-24 lg:py-32">
        <div className="ambient-orange pointer-events-none absolute -left-40 top-0 h-[500px] w-[500px]" />
        <div className="ambient-magenta pointer-events-none absolute -right-40 bottom-0 h-[500px] w-[500px]" />
        <div className="relative mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 lg:grid-cols-12 lg:px-8">
          <div className="lg:col-span-6">
            <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-orange">Get a Free Audit</p>
            <h2 className="font-display text-4xl font-extrabold leading-none tracking-tight sm:text-5xl lg:text-6xl">
              Find the revenue<br />hiding in your account.
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-muted">
              We'll review your campaigns, listings, content and creative — then show you exactly where the growth is. No cost, no obligation.
            </p>
            <div className="mt-10 space-y-4">
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="group flex items-center gap-3 text-sm text-muted hover:text-white">
                <Mail className="h-4 w-4 text-orange" /> {CONTACT.email}
              </a>
              <a href={`tel:${CONTACT.phoneHref}`} data-testid="footer-phone" className="group flex items-center gap-3 text-sm text-muted hover:text-white">
                <Phone className="h-4 w-4 text-magenta" /> {CONTACT.phone}
              </a>
              <p className="flex items-start gap-3 text-sm text-muted">
                <MapPin className="mt-0.5 h-4 w-4 text-indigo-bright" /> {CONTACT.location}
              </p>
            </div>
          </div>
          <div className="lg:col-span-6">
            <div className="glass rounded-2xl p-6 lg:p-8">
              <LeadForm idPrefix="footer-lead" />
            </div>
          </div>
        </div>
      </section>

      <div className="border-t border-white/5">
        <div className="mx-auto max-w-7xl px-5 py-10 lg:px-8">
          <p className="mb-7 text-center font-mono text-xs uppercase tracking-[0.3em] text-muted">
            Official platform partners
          </p>
          <PartnerBadgeRow variant="footer" />
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 px-5 py-8 lg:flex-row lg:px-8">
          <div className="flex items-center gap-3">
            <img src="/dna-logo.png" alt="DNA eCommerce Ads" className="h-8 w-auto" />
          </div>
          <div className="flex items-center gap-6 text-sm text-muted">
            <Link to="/blog" className="hover:text-white" data-testid="footer-blog-link">Blog</Link>
          </div>
          <p className="text-xs text-muted">© {new Date().getFullYear()} DNA eCommerce Ads. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
